'use client';

import { FC, PropsWithChildren } from 'react';

import AppWrapper from '@/components/layouts/main';

const App: FC<PropsWithChildren> = ({ children }) => (
  <AppWrapper>
    { children }
  </AppWrapper>
);
export default App;
